import InputWrapper from "../../../../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../../../styles/LayoutStyles";

function LabelFormView({
  printerData,
  onLabelWidthChange,
  onLabelHeightChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <StyledFlexRow>
        <StyledFlexItem>
          <InputWrapper
            label={translate("eva.main.validation.attributes.label_width")}
            required
            error={EVAApiHelper.getResponseError("label_width", submitError)}
          >
            <StyledInput
              type="number"
              value={printerData.label_width}
              onChange={onLabelWidthChange}
            />
          </InputWrapper>
        </StyledFlexItem>

        <StyledFlexItem>
          <InputWrapper
            label={translate("eva.main.validation.attributes.label_height")}
            required
            error={EVAApiHelper.getResponseError("label_height", submitError)}
          >
            <StyledInput
              type="number"
              value={printerData.label_height}
              onChange={onLabelHeightChange}
            />
          </InputWrapper>
        </StyledFlexItem>
      </StyledFlexRow>
    </StyledFlexColumn>
  );
}

export default LabelFormView;
